export class CardData {
    constructor(
        public systemId : string,
		public subSystemId: string,
		public value: string,
		public status: boolean
    ){}
}



// WEBPACK FOOTER //
// ./src/app/models/card-data.ts